import { render } from "./StudentInfo.vue?vue&type=template&id=3b5fbfe2&ts=true"
import script from "./StudentInfo.vue?vue&type=script&lang=ts"
export * from "./StudentInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/local/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__